import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

const StatusText = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  
  &.active {
    background-color: #DFF0EA;
    color: #5DB594;
  }
  
  &.inactive {
    color: #7B7B7B;
  }
`

const CollegeStatus = ({ status }) => {
  const getStatusClass = (status) => {
    // Convert status to number if it's a string
    const statusValue = typeof status === 'string' ? parseInt(status, 10) : status
    
    // Return active if status is 1 or true, otherwise inactive
    return statusValue === 1 || statusValue === true ? 'active' : 'inactive'
  }

  return (
    <StatusText className={getStatusClass(status)}>
      {getStatusClass(status) === 'active' ? 'Active' : '-'}
    </StatusText>
  )
}

export default CollegeStatus
